import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var AccountService = /** @class */ (function () {
    function AccountService(http, config) {
        this.http = http;
        this.config = config;
    }
    // get(id: number) {
    // 	return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/account` + id);
    // }
    AccountService.prototype.upsertSede = function (s) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/account/locations", s);
    };
    AccountService.prototype.deleteSede = function (id) {
        return this.http.delete(this.config.getConfig("apiEndpoint") + "/account/locations/" + id);
    };
    AccountService.prototype.getSedi = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/account/locations");
    };
    AccountService.prototype.update = function (ana) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/account", ana);
    };
    AccountService.ngInjectableDef = i0.defineInjectable({ factory: function AccountService_Factory() { return new AccountService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: AccountService, providedIn: "root" });
    return AccountService;
}());
export { AccountService };
